import { ReactNode } from "react";
import { Card, Space, Typography } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import { selectExtractedEntries } from "../../utils/extractedDataEntries";

const { Text } = Typography;

interface ExtractedDataCardProps {
  data: Record<string, unknown>;
  title?: string;
  icon?: ReactNode;
  filterKeys?: (key: string) => boolean;
  sortOrder?: string[];
  hideEmpty?: boolean;
}

const ExtractedDataCard = ({
  data,
  title = "Extracted Data",
  icon = <FileTextOutlined />,
  filterKeys,
  sortOrder,
  hideEmpty,
}: ExtractedDataCardProps) => {
  const entries = selectExtractedEntries(data, {
    filterKeys,
    sortOrder,
    hideEmpty,
  });

  if (entries.length === 0) return null;

  return (
    <Card
      size="small"
      title={
        <Space size={8}>
          <span style={{ color: "#1677ff" }}>{icon}</span>
          <Text strong>{title}</Text>
        </Space>
      }
      styles={{ body: { padding: 0 } }}
      style={{ borderRadius: 10 }}
    >
      {entries.map(({ key, label, value }) => (
        <div
          key={key}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 16,
            padding: "10px 16px",
            borderBottom: "1px solid #f1f5f9",
          }}
        >
          <Text type="secondary" style={{ textTransform: "capitalize" }}>
            {label}
          </Text>
          <Text strong style={{ textAlign: "right" }}>
            {value}
          </Text>
        </div>
      ))}
    </Card>
  );
};

export default ExtractedDataCard;
